<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div
    (cdkDragEnded)="dragEnded($event)"
    [config]="preloaderService.getLoadingConfig(loaderKey)"
    [suiIsLoading]="loaderKey"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    class="modal-window-content restorable-window preloader-wrapper"
>
    <div cdkDragHandle class="modal-header">
        <h4>PtP Info</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div *ngIf="!historyService || !reportData || !reportData.length" class="modal-body">
        <h6>No PtP links in this topology</h6>
    </div>
    <div *ngIf="historyService && reportData && reportData.length" class="modal-body modal-body--fixed-header">
        <div class="modal-body__fixed-header">
            <winde-tabs-nav
                (tabChanged)="changeTab($event)"
                *ngIf="tabsToShow && tabsToShow.length > 0"
                [activeTab]="currentTab"
                [customClass]="'tabs-nav--doc-tabs mb-1 report-tabs'"
                [tabsList]="tabsToShow"
                [translationPrefix]="'project.reportsTabs'"
            >
            </winde-tabs-nav>
        </div>

        <div #scrollContainer class="modal-body__scroll-content has-footer">
            <ng-container *ngIf="reportDataToShow?.length">
                <h6>Link information:</h6>
                <div class="grid">
                    <!-- HEADER -->
                    <div class="grid-row">
                        <div class="grid-row__cell">
                            <div>Distance</div>
                            <span class="font-weight-normal d-block"> ({{ historyService.logicalTopology?.productUnits }} ) </span>
                        </div>
                        <div class="grid-row__cell">Product</div>
                        <div *ngIf="layers" class="grid-row__cell">Layer</div>
                        <div class="grid-row__cell">Frequency</div>
                        <div class="grid-row__cell">Link</div>
                        <div class="grid-row__cell state-cell">Frozen / Installed</div>
                    </div>

                    <!-- BODY -->
                    <div
                        *ngFor="let link of reportDataToShow; trackBy: trackLinkData"
                        [ngClass]="{
                            'highlight-substring--blue': link['selected'],
                            'p2p-link-row--{{ link.node0Id }}-{{ link.node1Id }}': true
                        }"
                        class="grid-row"
                    >
                        <div class="grid-row__cell">
                            {{ link.distance | FeetConvert: historyService.logicalTopology?.productUnits }}
                        </div>
                        <div class="grid-row__cell">
                            {{ link.usedProductName }}
                        </div>
                        <div *ngIf="layers" class="grid-row__cell">{{ layers[link.layerIndex] }}</div>
                        <div class="grid-row__cell">{{ link.rxFreq }} / {{ link.txFreq }}</div>
                        <div class="grid-row__cell">
                            <winde-node-pointer
                                [listData]="{ nodeNames: link.desc, separateBy: ' - ', placement: 'top', cropName: 10 }"
                            ></winde-node-pointer>
                        </div>
                        <div class="grid-row__cell state-cell">
                            @if (link.isUserForced && !link.isInstalled) {
                                <button windeActionIcon>
                                    <sui-svg-icon icon="lock" windeGrey />
                                </button>
                            }
                            @if (link.isUserForced && link.isInstalled) {
                                <button windeActionIcon>
                                    <sui-svg-icon icon="podcast" windeGrey />
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="modal-footer-button">
            <button (click)="exportToExcel()" [disabled]="!reportDataToShow?.length" windeGreen>Export to Excel</button>
        </div>
    </div>
</div>
